module.exports = __webpack_public_path__ + "img/opendoor1.30bdc8a4.png";